import { useModel } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { Payment } from "../../api/payment";
import { PaymentData } from "../../api/paymentChange";
import { PaymentCount } from "../../api/paymentCount";
import { ConfirmAssetsDataStep } from "../confirm-assets-data-step";
import { PaymentExternalSystems } from "./externalSystems";
import { PaymentForm } from "./payment-form";
import { PaymentQuerry } from "./payment-querry";
import { PaymentTableColumns } from "./payment-table-columns";

export const ConfirmPaymentsDataStep = ({ isEdit, job, next, cancel, startOver, $refreshEvents }: { isEdit: boolean, job, next?, cancel?, startOver?, $refreshEvents? }) => {
    const paymentChanges = useModel(PaymentData);
    const paymentCountModel = useModel(PaymentCount);
    const paymentQuerryModel = useModel(PaymentQuerry);

    return <>
        <ConfirmAssetsDataStep
            isEdit={isEdit}
            job={job}
            assetName="Payment"
            assetType={AssetType.payment}
            assetModel={Payment}
            countModel={paymentCountModel}
            queryModel={paymentQuerryModel}
            tableColumns={PaymentTableColumns}
            assetChanges={paymentChanges}
            next={next} cancel={cancel} startOver={startOver}
            externalSystems={PaymentExternalSystems}
            $refreshEvents={$refreshEvents}
            assetForm={payment => <PaymentForm payment={payment} />}
        />
    </>
}
